import axios from "axios";
import { backendURL } from "../url";
import type {
  ReferralBenefit,
  ReferralListItem,
  ReferralSummary,
  ReferralValidateResult,
} from "../schemas/referral";

const API_URL = `${backendURL}/api/referrals`;

const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`,
  "Content-Type": "application/json",
});

export const getReferralSummary = async (): Promise<ReferralSummary> => {
  const response = await axios.get(`${API_URL}/summary`, {
    headers: authHeaders(),
  });
  return response.data;
};

export const getReferralList = async (): Promise<ReferralListItem[]> => {
  const response = await axios.get(`${API_URL}/list`, {
    headers: authHeaders(),
  });
  return response.data.referrals;
};

export const sendReferralInvite = async (email: string) => {
  const response = await axios.post(
    `${API_URL}/invite`,
    { email },
    { headers: authHeaders() }
  );
  return response.data;
};

export const validateReferralCode = async (
  referralCode: string
): Promise<ReferralValidateResult> => {
  // The token is optional here: sending it lets the backend also report whether
  // the signed-in user is allowed to use this code.
  const token = localStorage.getItem("token");
  const response = await axios.post(
    `${API_URL}/validate`,
    { referralCode },
    token ? { headers: authHeaders() } : undefined
  );
  return response.data;
};

/**
 * Records the code against the signed-in account so the referral survives a
 * cleared browser or a login weeks later, instead of living only in
 * localStorage until checkout.
 */
export const attributeReferralCode = async (referralCode: string) => {
  const response = await axios.post(
    `${API_URL}/attribute`,
    { referralCode },
    { headers: authHeaders() }
  );
  return response.data;
};

export const getMyReferralBenefit = async (): Promise<ReferralBenefit> => {
  const response = await axios.get(`${API_URL}/my-benefit`, {
    headers: authHeaders(),
  });
  return response.data;
};
